<template>
	<div class="title">订单查询</div>
	<!-- 搜索栏 -->
	<el-form ref="formRef" :model="searchForm" inline>
		<el-form-item label="单号：" prop="OrderNo">
			<el-input v-model="searchForm.OrderNo" placeholder="请输入单号" style="width:120px;" clearable @change="changeInputVal"></el-input>
		</el-form-item>
		<el-form-item label="下单日期：" prop="OrderTime">
			<el-date-picker v-model="searchForm.OrderTime" type="daterange" start-placeholder="开始时间"
				end-placeholder="结束时间" range-separator="至" :default-value="[new Date()]" clearable
				@change="changeOrderTime(searchForm.OrderTime)" />
		</el-form-item>
		<el-form-item label="发货日期：" prop="SaleDate">
			<el-date-picker v-model="searchForm.SaleDate" type="daterange" start-placeholder="开始时间"
				end-placeholder="结束时间" range-separator="至" :default-value="[new Date()]" clearable
				@change="changeSaleDate(searchForm.SaleDate)" />
		</el-form-item>
		<el-form-item label="">
			<el-button type="primary" @click="getOrderList">查询</el-button>
		</el-form-item>
	</el-form>
	<!-- 表格 -->
	<el-table :data="state.data" border style="width: 100%" table-layout="auto" v-loading="state.loading"
		empty-text="没有找到相关信息！" :header-cell-style="{ background:'#f2f2f2',color:'#3a3a3a'}">
		<el-table-column prop="OrderTime" label="下单日期" align="center">
			<template #default="scope">
				<span>{{ moment(scope.row.OrderTime).format('YYYY-MM-DD') }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="SaleDate" label="发货日期" align="center">
			<template #default="scope">
				<span>{{ moment(scope.row.SaleDate).format('YYYY-MM-DD') }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="OrderNo" label="单号" align="center"></el-table-column>
		<el-table-column prop="OrderTotalCount" label="订购数量" align="center"></el-table-column>
		<el-table-column prop="OrderLackCount" label="缺货数量" align="center"></el-table-column>
		<el-table-column prop="EffectiveTotalCount" label="有效数量" align="center"></el-table-column>
		<el-table-column prop="OrderTotalAmount" label="订购金额" align="center">
			<template #default="scope">
				<span>{{ scope.row.OrderTotalAmount.toFixed(2) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="OrderLacklAmount" label="缺货金额" align="center">
			<template #default="scope">
				<span>{{ scope.row.OrderLacklAmount.toFixed(2) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="EffectiveTotalAmount" label="有效金额" align="center">
			<template #default="scope">
				<span>{{ scope.row.EffectiveTotalAmount.toFixed(2) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="OrderStatus" label="订单状态" align="center">
			<template #default="scope">
				<span v-if="scope.row.OrderStatus==0">未提交</span>
				<span v-if="scope.row.OrderStatus==1">已提交</span>
				<span v-if="scope.row.OrderStatus==2">已发货</span>
				<span v-if="scope.row.OrderStatus==3">已收货</span>
				<span v-if="scope.row.OrderStatus==8">已完成</span>
			</template>
		</el-table-column>
		<el-table-column prop="operation" label="操作" align="center">
			<template #default="scope">
				<el-button text @click="toDetails(scope.row.Id)" style="color:#38adff">详情</el-button>
				<el-button v-if="scope.row.OrderStatus==2" text @click="confirmReceipt(scope.row.Id)" style="margin-left:5px;color:#38adff">确认收货</el-button>
			</template>
		</el-table-column>
	</el-table>
	<div class="u-pagination">
		<el-pagination background :current-page="state.params.limit.conditions.pageStart"
			:page-size="state.params.limit.conditions.pageLength" layout="prev, pager, next" prev-text="上一页"
			next-text="下一页" :total="state.total" @current-change="handleCurrentChange"
			@size-change="handleSizeChange"></el-pagination>
	</div>
	<order-details-dialog ref="orderDetailsRef"></order-details-dialog>
</template>

<script setup>
	import {
		reactive,
		ref,
		onMounted
	} from 'vue';
	import {
		webMainOrderList,orderConfirmReceipt
	} from '@/api/user';
	import moment from 'moment';
	import {ElMessage} from 'element-plus'
	import orderDetailsDialog from './orderDetailsDialog.vue';

	const searchForm = reactive({
		OrderNo: '',
		SaleDate: '',
		OrderTime:''
	});
	//数据源
	const state = reactive({
		startOrderTime:'',
		endOrderTime:'',
		startSaleDate:'',
		endSaleDate:'',
		params: {
			filters: {
				enable: true,
				join:'and',
				conditions: []
			},
			limit: {
				enable: true,
				conditions: {
					pageLength: 15,
					pageStart: 1
				}
			}
		},
		data: [], //表格数据
		total: 0,
		loading: true
	})
	
	// 订单详情
	const orderDetailsRef = ref();
	const toDetails = (Id) =>{
		orderDetailsRef.value.onChangeVisible(Id);
	}
	
	onMounted(async () => {
		await initData();
	})
	
	const changeInputVal=()=>{
		getOrderList()
	}
	//处理下单时间
	const changeOrderTime = (val) => {
		if (val) {
			const v = JSON.parse(JSON.stringify(val))
			state.params.startOrderTime = moment(v[0]).format('YYYY-MM-DD')
			state.params.endOrderTime = moment(v[1]).format('YYYY-MM-DD')
			
		} else {
			state.params.startOrderTime = ''
			state.params.endOrderTime = ''
			getOrderList()
		}
		
	}
	//处理发货时间
	const changeSaleDate = (val) => {
		if (val) {
			const v = JSON.parse(JSON.stringify(val))
			state.params.startSaleDate = moment(v[0]).format('YYYY-MM-DD')
			state.params.endSaleDate = moment(v[1]).format('YYYY-MM-DD')
			
		} else {
			state.params.startSaleDate = ''
			state.params.endSaleDate = ''
			getOrderList()
		}
		
	}
	/**
	 * 初始化数据
	 * @param {无}
	 */
	const initData = async () => {
		await getOrderList()
	}
	/**
	 * 获取订单查询列表
	 * @param {无}
	 */
	const getOrderList = () => {
		state.params.filters.conditions = [];
		state.loading = true
		state.params.filters.conditions.push({
			name:'OrderNo',
			type:'like',
			value: searchForm.OrderNo
		})
		return webMainOrderList(state.params).then(res => {
			const {data: {filterAmount,records}} = res
			state.data = records.map(item => {
				return {...item}
			})
			state.total = filterAmount
			state.loading = false
		})
	}
	/**
	 * 确认收货
	 * @param {id}
	 */
	const confirmReceipt=async(Id)=>{
		await orderConfirmReceipt({id:Id}).then(() => {
			ElMessage({message: '确认收货成功',type: 'success',duration:1000})
			getOrderList()
		})
	}
	/**
	 * 改变页码
	 * @param {number} val 
	 */
	const handleCurrentChange = (val) => {
		state.params.limit.conditions.pageStart = val;
		getOrderList()
	};
	/**
	 * 改变页数限制
	 * @param {number} val 
	 */
	const handleSizeChange = (val) => {
		state.params.limit.conditions.pageLength = val;
		getOrderList()
	};
</script>

<style lang="scss" scoped>
	.title {
		font-size: 18px;
		font-weight: bold;
		color: #3A3A3A;
		line-height: 55px;
	}
	
</style>